import { UNFORMATTED } from 'customer-data-objects/property/NumberDisplayHint';
import { isCurrency, isNumber, isPropertySourceUserId } from 'customer-data-objects/property/PropertyIdentifier';
import { parsePropertySourceUserId } from 'customer-data-objects/property/PropertySourceIdentifier';
import { useContext, useMemo } from 'react';
import { PropertyContext } from '../context/PropertyContext';
export const usePropertyValue = () => {
  const {
    property,
    value
  } = useContext(PropertyContext);
  return useMemo(() => {
    // If a value can be read in standard format, do so;
    // otherwise, try local format
    if (isNumber(property) && !isCurrency(property) && value && property.numberDisplayHint !== UNFORMATTED) {
      return isNaN(Number(value)) ? // @ts-expect-error I18n isn't typed yet
      I18n.parseNumber(value, {
        precision: 5
      }) : Number(value);
    }

    if (value && isPropertySourceUserId(property, value)) {
      return parsePropertySourceUserId(value);
    }

    return value;
  }, [property, value]);
};